import { useCallback } from 'react';
import { setRef } from '../helpers/refs';
export var useCombineRefs = function useCombineRefs() {
  for (var _len = arguments.length, refCallbacks = new Array(_len), _key = 0; _key < _len; _key++) {
    refCallbacks[_key] = arguments[_key];
  }

  return useCallback(function (ref) {
    refCallbacks.forEach(function (refCallback) {
      return setRef(refCallback, ref);
    });
  }, refCallbacks);
};